import { APICore } from './apiCore'

const api = new APICore()

function getNoticias (params) {
  const baseUrl = '/noticias'
  return api.get(baseUrl, params)
}

function getNoticia (id) {
  const baseUrl = `/noticias/${id}`
  return api.get(baseUrl, {})
}

function addNoticia (params) {
  const baseUrl = '/noticias'
  return api.createWithFile(baseUrl, params)
}

function updateNoticia (params) {
  const baseUrl = '/noticias'
  return api.updateWithFile(baseUrl, params)
}

function deleteNoticia (params) {
  const baseUrl = '/noticias'
  return api.delete(baseUrl, params)
}

export { getNoticias, getNoticia, addNoticia, updateNoticia, deleteNoticia }
